import { useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { selectFederalSources } from '../store/selectors'
import { useMemo } from 'react'

/**
 * Custom hook to get federal court selections from Redux state
 *
 * Returns:
 * - selectedFederalCourts: Array of jurisdiction codes currently selected (both courts and LRR sources)
 *
 * This hook provides read-only access to the federal court selections
 * stored in researchFiltersState for the specified conversation.
 */
export function useFederalSelection(conversationId: string) {
  // Get federal sources from researchFiltersState
  const federalSources = useAppSelector((state: RootState) => selectFederalSources(state, { conversationId }))

  // Combine federal courts with LRR sources for checkbox state (this is what the UI expects)
  const selectedFederalCourts = useMemo(() => {
    return [...federalSources.caselaw, ...federalSources.lrr]
  }, [federalSources])

  return { selectedFederalCourts }
}
